import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("y-input-wrapper", null, [
    _createElementVNode("label", {
      slot: "label",
      for: $setup.randomId
    }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_1),
    _createVNode($setup["DatePicker"], {
      "min-date": $props.minDate,
      "input-id": $setup.randomId,
      placeholder: $props.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => _ctx.$emit('update:modelValue', val))
    }, null, 8 /* PROPS */, ["min-date", "input-id", "placeholder"])
  ]))
}